import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { FaCheck } from "react-icons/fa";
import Footer from "components/Footers/Footer";
import { HashLink } from "react-router-hash-link";
import { useSize } from "components/SizeControl/SizeControl";
import { Accordion, AccordionTab } from "primereact/accordion";
import imageHeader from "../assets/ossaPictures/hakkimizdaHeader.jpeg";
import PictureHeader from "components/PictureHeader/PictureHeader";
import { useNavigate } from "react-router-dom";
import DynamicCardSection from "components/Hizmetlerimiz/DynamicCardSectionHome";

const AileHukuku = () => {
  const { under1200, under992 } = useSize();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    // Sayfa yüklendiğinde .gt-lang-code elementini bul ve değişiklik yap
    const targetLink = document.querySelector('a[data-gt-lang="tr"]'); // Değiştirmeniz gereken class veya id'yi buraya ekleyin

    if (targetLink) {
      // Otomatik tıklama
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png"; // Değiştirmeniz gereken yeni resim yolunu buraya ekleyin
      console.log(imgElement);
      imgElement.src = newImgSrc;
      imgElement.width = "32";
      imgElement.height = "32";
    }
  }, []);

  return (
    <>
      <Helmet>
      <title>ÇALIŞMA ALANLARIMIZ | AİLE HUKUKU | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="ARS HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com"
        />
        <meta property="og:title" content="HAKKIMIZDA | ARS HUKUK" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="ARS HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com"
        />
      </Helmet>
      <WhiteNavbar navbarSelection={"about-us"} />
      {/* <PictureHeader imageHeader={imageHeader} />
       */}
       <br></br><br></br><br></br><br></br>

      <div>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div>
            <br></br>

            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>AİLE HUKUKU</b>
            </h2>
          </div>
          <Row>
            <Col className="ml-auto" md="6" style={{ alignContent: "center" }}>
              <img
                alt="Aile Hukuku"
                className="img rounded"
                src={require("assets/arsPictures/hizmetler/aileHukuku.png")}
              ></img>
            </Col>
            <Col
              className="mr-auto mt-5 mt-md-3"
              md="6"
              data-aos="zoom-in"
              data-aos-duration="2000"
              style={{ alignSelf: "center" }}
            >
            <p>
            Aile Hukukuna konu olan uyuşmazlıklar, çoğunlukla boşanma, nafaka, maddi-manevi tazminat, velayet, mal rejimi, soy bağı, evlat edinme ve aile içi şiddet gibi konulardır. Boşanma davalarında, eşler arasında mal paylaşımı, nafaka yükümlülükleri ve ortak çocukların velayeti gibi önemli meseleler birlikte incelenir. Bu davalarda çocukların üstün yararı gözetilerek, velayet sahibi olmayan ebeveynle kişisel ilişki kurma şartları da belirlenir.</p>
            <br></br>
            
            



            </Col>
          </Row>
          {/* <Row>
            
            <Col
              className="mr-auto mt-5 mt-md-3"
              md="12"
              data-aos="zoom-in"
              data-aos-duration="2000"
              style={{ alignSelf: "center" }}
            >
            
            <p>
            Diğer önemli aile hukuku konuları velayet, nafaka ve evlat edinmedir. Velayet davaları, bir çiftin ayrılmasının ardından çocukların velayetinin kime ait olduğuna ilişkin hukuki sorunları çözmeyi amaçlamaktadır. Öte yandan diğer davalar, boşanma sonrasında bir tarafın diğerine sürekli olarak mali destek vermesiyle ilgili hukuki meselelerle ilgilidir. Son olarak evlat edinme davaları, başka bir aileden gelen bir çocuğun yasal olarak evlat edinilmesi için gerekli olan yasal prosedürleri içerir.
            </p>



            </Col>
          </Row> */}
          <div className="title">
            <br></br>

            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>SIKÇA SORULAN SORULAR</b>
            </h2>
          </div>
          <br></br>
          <div className="card">
          <Accordion activeIndex={0}>
            <AccordionTab header="Boşanma davası nasıl açılır?">
              <p className="m-0">
              Tarafların anlaşmasına göre boşanmanın karşılıklı anlaşmayla mı yoksa anlaşmazlıkla mı gerçekleşeceğine karar verilmesi gerekir. Her iki taraf da boşanmak istiyorsa ve boşanmanın diğer hususları üzerinde anlaşıyorsa, anlaşmalı boşanma mümkündür. Taraflardan yalnızca biri boşanmak istiyorsa veya her iki taraf da boşanmak istiyorsa ancak boşanmanın diğer mali konularında anlaşmazlıklar varsa, anlaşmalı boşanma mümkün değildir ve çekişmeli boşanma davasında rücuya başvurulması zorunludur.
              </p>
            </AccordionTab>
            <AccordionTab header="Boşanma davasına katılmak zorunlu mu?">
              <p className="m-0">
              Dava açan tarafın açtığı boşanma davasında kendisini temsil edecek avukatı yoksa davaya katılması gerekmektedir. Sözlü yargılamaya katılmayan taraf konuyu ele almadığından dosya başvurudan çıkarılır. Sanık duruşmaya katılmamalıdır. Ancak davada kendisini savunabilmesi ve dava açabilmesi için duruşmaya katılması veya tarafların karşılıklı anlaşmasıyla ayrılması halinde kendisini bir avukat tarafından temsil etmesi gerekir. Boşanma anlaşmasında taraflar avukatla temsil edilseler dahi yargılamaya kendilerinin katılması gerekmektedir. Taraflar yargılamaya katılmazlarsa dava takip edilmeyeceği için boşanma da gerçekleşmeyecektir.
              </p>
            </AccordionTab>
            <AccordionTab header="Boşanma Sebepleri Nelerdir?">
              <p className="m-0">
              Türk Medeni Kanunu’nda boşanma sebepleri sınırlı sayıda sayılmıştır. Kanunda bulunmayan bir sebebe dayanarak boşanma davası açılması yasal olarak mümkün değildir. Bu nedenle boşanmak isteyen kişi, neden boşanmak istediğini ve bu boşanma sebebinin kanunen hangi boşanma sebebine girdiğini bilerek ve dilekçesinde bunları gerekçeli şekilde belirterek dava açmalıdır. Türk Medeni Kanunu’na göre boşanma sebepleri:<br/><br/>
                  -Evlilik birliğinin temelden sarsılması (şiddetli geçimsizlik),<br/>
                  -Zina (aldatma),<br/>
                  -Akıl hastalığı,<br/>
                  -Terk,<br/>
                  -Hayata kast, pek kötü veya onur kırıcı davranış,<br/>
                  -Suç işleme ve haysiyetsiz hayat sürme.
              </p>
            </AccordionTab>
            {/* <AccordionTab header="Aile Hukuku nedir?">
              <p className="m-0">
                Aile hukuku, aile içi ilişkileri ve bu ilişkilerden doğan hukuki sonuçları düzenleyen bir hukuk dalıdır. Bu alan, evlilik, boşanma, velayet, mal rejimi, nafaka ve soybağı gibi konuları kapsar.
              </p>
            </AccordionTab>
            <AccordionTab header="Aile Hukuku kimleri kapsar?">
              <p className="m-0">
                Aile hukuku, evli çiftler, boşanmış eşler, çocuklar, ebeveynler ve diğer aile bireyleri arasındaki hukuki ilişkileri kapsar. Aile içi anlaşmazlıkların çözümünde ve aile bireylerinin haklarının korunmasında önemli bir rol oynar.
              </p>
            </AccordionTab>
            <AccordionTab header="Aile Hukuku neden önemlidir?">
              <p className="m-0">
                Aile hukuku, aile bireylerinin hak ve yükümlülüklerini düzenler ve korur. Aile içi anlaşmazlıkların çözümü, çocukların haklarının korunması ve aile içi huzurun sağlanması açısından kritik öneme sahiptir.
              </p>
            </AccordionTab>
            <AccordionTab header="Boşanma davalarında neler yapılabilir?">
              <p className="m-0">
                Boşanma davalarında, evliliğin sona erdirilmesi, nafaka talepleri, velayet ve mal paylaşımı konuları ele alınır. ARS Hukuk Bürosu, müvekkillerine boşanma sürecinde hukuki destek sağlamaktadır.
              </p>
            </AccordionTab>
            <AccordionTab header="Velayet davalarında ne yapılabilir?">
              <p className="m-0">
                Velayet davalarında, çocuğun hangi ebeveynle kalacağı ve ebeveynlerin çocuğa dair hak ve sorumlulukları belirlenir. Çocuğun en iyi menfaatlerinin gözetilmesi esastır ve ARS Hukuk Bürosu bu süreçte müvekkillerine profesyonel hukuki destek sunar.
              </p>
            </AccordionTab>
            <AccordionTab header="Nafaka nedir ve nasıl talep edilir?">
              <p className="m-0">
                Nafaka, boşanma sonrası bir eşin diğerine veya çocuklarına maddi destek sağlamasıdır. Nafaka talebi, mahkemeye başvurarak yapılır ve nafakanın miktarı mahkeme tarafından belirlenir. ARS Hukuk Bürosu, nafaka talepleri konusunda hukuki danışmanlık ve temsil hizmeti sunmaktadır.
              </p>
            </AccordionTab>
            <AccordionTab header="Aile içi şiddet durumunda neler yapılabilir?">
              <p className="m-0">
                Aile içi şiddet durumunda, şiddet mağdurları korunma talepleriyle mahkemeye başvurabilir ve koruyucu tedbirler talep edebilir. ARS Hukuk Bürosu, aile içi şiddet durumlarında hukuki destek ve danışmanlık hizmeti sunar.
              </p>
            </AccordionTab>
            <AccordionTab header="Aile hukuku danışmanlık süreci nasıl işler?">
              <p className="m-0">
                Aile hukuku danışmanlık süreci, müvekkilin ihtiyaç ve durumunun değerlendirilmesiyle başlar. Ardından, hukuki gereklilikler doğrultusunda danışmanlık hizmeti sunulur ve gerekli hukuki adımlar atılır. ARS Hukuk Bürosu, bu sürecin her aşamasında profesyonel destek sağlar.
              </p>
            </AccordionTab>
            <AccordionTab header="ARS Hukuk Bürosu'na kimler başvurabilir?">
              <p className="m-0">
                ARS Hukuk Bürosu'na, aile hukuku alanında hukuki danışmanlık ve destek almak isteyen herkes başvurabilir. Evli çiftler, boşanmış eşler, ebeveynler ve diğer aile bireyleri hukuki hizmetlerden faydalanabilirler.
              </p>
            </AccordionTab> */}
          </Accordion>



          </div>
          <div className="team-2 pb-0 pt-0">
            <DynamicCardSection />
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default AileHukuku;
